import React from "react";
import themes from "../themes";
import Utils from "../utils/utils";

export default class FixButton extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: this.props.value, 
            hovering: false,
        }
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange)
            this.props.onChange(event.target.value)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    render (){

        return ( 
            <button
                onClick={async () => {
                    this.props.callback();
                }}
                style={{ transition: 'all .3s', marginBottom: '10px', marginLeft: '5px', padding: '10px', backgroundColor: (this.props.type && this.props.type === 'error') ? '#DE493F' : this.state.hovering ? themes.default.palette.textColor.shadowColor : themes.default.palette.secondary.main, cursor: 'pointer', borderRadius: '5px', border: '0px', color: Utils.getTextColorFromBackground(this.props.type ? '#DE493F' : themes.default.palette.secondary.main), boxShadow: this.state.hovering ? '0px 2px 5px darkgrey' : '0px 2px 5px lightgrey' }} 
                onMouseEnter={() => this.setState({ hovering: true })}
                onMouseLeave={() => this.setState({ hovering: false })}>
                    {this.props.title}
            </button>
        )
    }

}